import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { emailValidator } from '../email';
import { apiCall } from '../API';
import AsyncActionStore from './AsyncActionStore';
import InputStore from './InputStore';
import FlagStore from './FlagStore';

export default class ConsoleLoginStore {
    static PropType = PropTypes.shape({
        accountLockoutMin: PropTypes.number.isRequired,
        email: InputStore.PropType.isRequired,
        password: InputStore.PropType.isRequired,
        isAccountLocked: PropTypes.bool.isRequired,
        isServerValidationFailed: PropTypes.bool.isRequired,
        submit: PropTypes.func.isRequired,
        canSubmit: PropTypes.bool.isRequired,
        redirectUrl: PropTypes.string.isRequired,
        preLoginSubmit: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class ConsoleLoginStore */{
            accountLockoutMin: 5,
            apiSubmit: apiCall('/console'),
            apiSubmitState: new AsyncActionStore({ label: 'ConsoleLoginStore.apiSubmit' }),
            apiEmailSubmit: apiCall('/sso/login/validate'),
            apiEmailSubmitState: new AsyncActionStore(),
            apiSSOLogin: apiCall('/sso/console/start'),
            apiSSOLoginState: new AsyncActionStore(),
            email: new InputStore({ value: '', isTouched: true }),
            password: new InputStore({ value: '', isTouched: true }),
            redirectUrl: '/console/index',
            passwordVisibility: new FlagStore(false),
            isSSO: new FlagStore(false),

            get isAccountLocked() {
                return !!this.apiSubmitState.error && (this.apiSubmitState.error.class === 'LockedException');
            },

            get isServerValidationFailed() {
                return !!this.apiSubmitState.error && !this.isAccountLocked;
            },

            get canSubmitPreLogin() {
                return !this.email.isEmpty;
            },

            get canSubmit() {
                return !this.email.isEmpty && !this.password.isEmpty;
            },
        }, data);

        this.email.setValidator(emailValidator);
    }

    onSSOButtonClick = action(() => {
        if (!this.apiSSOLoginState.isLoading) {
            this.apiSSOLoginState.setLoading(this.apiSSOLogin({ value: this.email.value }).then((response) => {
                window.location = response.value;
            }));
        }
        return this.apiSSOLoginState.promise;
    });

    preLoginSubmit = action(() => {
        if (!this.apiEmailSubmitState.isLoading) {
            this.apiEmailSubmitState.setBase();

            this.email.setTouched(false);

            if (!this.email.isValid) {
                this.email.focus();
                return Promise.reject();
            }

            this.apiEmailSubmitState.setLoading(this.apiEmailSubmit({ value: this.email.value })
                .then((response) => {
                    this.isSSO.setValue(response);
                }));
        }
        return this.apiEmailSubmitState.promise;
    });

    submit = action(() => {
        if (!this.apiSubmitState.isLoading) {
            this.apiSubmitState.setBase();

            this.email.setTouched(false);
            this.password.setTouched(false);

            if (!this.email.isValid) {
                this.email.focus();
                return Promise.reject();
            }

            this.apiSubmitState.setLoading(this.apiSubmit({
                email: this.email.value,
                password: this.password.value,
            }));
        }
        return this.apiSubmitState.promise;
    });
}
